import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';

/**
 * Light (parchment) / dark (navy) toggle. Writes `data-theme` on <html> so the explicit choice wins
 * over `prefers-color-scheme` in both directions (MASTER.md). Null = follow the system until toggled.
 */
export function useTheme(): [Theme | null, () => void] {
  const [theme, setTheme] = useState<Theme | null>(null);

  useEffect(() => {
    if (theme) document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggle = () => {
    setTheme((prev) => {
      const current: Theme =
        prev ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
      return current === 'dark' ? 'light' : 'dark';
    });
  };

  return [theme, toggle];
}
